__turbopack_context__.v({
  "favorite-icon": "favorite-module-scss-module__GczDAG__favorite-icon",
});
